module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo04.ed0bb33c.jpg";